import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function VideoWithEndImage({ video, image }) {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  const [videoEnded, setVideoEnded] = useState(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Content animation
      // gsap.from(contentRef.current, {
      //   y: 50,
      //   opacity: 0,
      //   duration: 1,
      //   ease: "power3.out",
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 80%",
      //     toggleActions: "play none none none",
      //   },
      // });

      // // Image animation (bottom → top)
      gsap.from(titleRef.current, {
        y: -120,
        opacity: 0,
        delay: 0.5,
        duration: 2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={sectionRef}
      style={{ position: "relative", width: "100%", height: "100vh" }}
    >
      <p
        ref={titleRef}
        style={{
          position: "absolute",
          top: "50px",
          fontSize: "80px",
          textAlign: "center",
          color: "#13435c",
          fontWeight: 700,
          width: "100%",
        }}
      >
        Ocean Bay
      </p>
      <video
        width="100%"
        autoPlay
        muted
        playsInline
        onEnded={() =>
          setTimeout(() => {
            setVideoEnded(true);
          }, 2000)
        }
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          // transition: "all 0.5s ease",
          opacity: videoEnded ? 0 : 1,
          zIndex: 10,
        }}
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <img
        src={image}
        alt="Last frame"
        width="100%"
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          // transition: "all 0.5s ease",
          opacity: videoEnded ? 1 : 0,
          zIndex: 10,
        }}
      />
    </div>
  );
}

export default VideoWithEndImage;
